// extracted by mini-css-extract-plugin
export default {"Container":"UpdatedBy-module__Container__wmAzHNj","UserLink":"UpdatedBy-module__UserLink__wlZpY8o","GitHubAvatar":"UpdatedBy-module__GitHubAvatar__vlAJnqG"};